module.exports = __webpack_public_path__ + "overview-a5b6df21/about-us-7ccfbb0b9f3f93cf70a4a5e08a9c1ce8.svg";